var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5 0L51.35 6.875L44.5 10L51.35 13.15L54.5 20L57.625 13.15L64.5 10L57.625 6.875L54.5 0ZM26.8281 35.0026C28.3837 36.5582 30.2726 37.3359 32.4948 37.3359C34.717 37.3359 36.6059 36.5582 38.1615 35.0026C39.717 33.447 40.4948 31.5582 40.4948 29.3359V13.3359C40.4948 11.1137 39.717 9.22483 38.1615 7.66927C36.6059 6.11372 34.717 5.33594 32.4948 5.33594C30.2726 5.33594 28.3837 6.11372 26.8281 7.66927C25.2726 9.22483 24.4948 11.1137 24.4948 13.3359V29.3359C24.4948 31.5582 25.2726 33.447 26.8281 35.0026ZM29.8281 47.8026V56.0026H35.1615V47.8026C39.7837 47.1804 43.6059 45.1137 46.6281 41.6026C49.6503 38.0915 51.1615 34.0026 51.1615 29.3359H45.8281C45.8281 33.0248 44.5281 36.1693 41.9281 38.7693C39.3281 41.3693 36.1837 42.6693 32.4948 42.6693C28.8059 42.6693 25.6615 41.3693 23.0615 38.7693C20.4615 36.1693 19.1615 33.0248 19.1615 29.3359H13.8281C13.8281 34.0026 15.3392 38.0915 18.3615 41.6026C21.3837 45.1137 25.2059 47.1804 29.8281 47.8026Z",
    fill: "#440FCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalMic);
export default __webpack_public_path__ + "static/media/modal-mic.29e0f72e02b316103166c6824ea15d2a.svg";
export { ForwardRef as ReactComponent };